import { Modal, ModalContent, ModalHeader, ModalBody } from "@nextui-org/react";

interface MethologFobExportersModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const MethologFobExportersModal = ({ isOpen, onClose }: MethologFobExportersModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
        size='lg'
      >
        <ModalContent>
          <ModalHeader>¿Cómo lo calculamos?</ModalHeader>
          <ModalBody className='pb-6'>
            <div className='space-y-4'>
              <div>
                <p className='text-default-500 mb-2'>
                  Ambas metodologías comparan dos grupos: las liquidaciones
                  propias vs las liquidaciones del resto de exportadoras que
                  usan CherryMarket, usando un análisis de cuartiles.
                </p>
                <p className='text-default-500 mb-2 font-bold'>
                  Difieren en cómo se arman los cuartiles.
                </p>
              </div>

              <p className='text-default-500 text-lg mb-2 font-bold'>
                  1. Ponderación.
                </p>
              <div>
                <h3 className='font-semibold text-lg mb-2'>Por Exportadora</h3>
                <p className='text-default-500'>
                  Se calcula el FOB/CIF promedio de cada exportadora y luego para
                  generar los cuartiles se da igual peso a cada exportadora,
                  independientemente de su volumen de ventas.
                </p>
              </div>
              <div>
                <h3 className='font-semibold text-lg mb-2'>Por Volumen</h3>
                <p className='text-default-500'>
                  Cada exportadora contribuye con sus kilos al cálculo final de
                  los cuartiles. Esto significa que las exportadoras con mayor
                  volumen de ventas tendrán un mayor impacto en las estadísticas
                  finales.
                </p>
              </div>
              <p className='text-default-500 text-lg mb-2 font-bold'>
                  2. Fecha.
                </p>
              <div>
                <h3 className='font-semibold text-lg mb-2'>Fecha Venta Liquidación</h3>
                <p className='text-default-500'>
                  Se agrupan las liquidaciones por fecha de venta.
                </p>
              </div>
              <div>
                <h3 className='font-semibold text-lg mb-2'>Fecha Arribo Nave</h3>
                <p className='text-default-500'>
                  Se agrupan las liquidaciones por fecha de arribo de la nave.
                </p>
              </div>
              <div>
                <h3 className='font-semibold text-lg mb-2'>Fecha Zarpe Nave</h3>
                <p className='text-default-500'>
                  Se agrupan las liquidaciones por fecha de zarpe de la nave.
                </p>
              </div>            </div>
          </ModalBody>
        </ModalContent>
    </Modal>
  );
};

export default MethologFobExportersModal;
